//messages.js
export default {
    shipment_id: "Shipment Id",
    company_id: "Company Id",
    truck_id: "Truck Id",
    vehicle_id: "Vehicle Id",
    load_date: "Load Date",
    deliver_date: "Deliver Date",
    delivered_by: "Delivered By",
    status_id: "Status Id",
    edit_shipment_planner: "Edit Shipment Planner",
    add_shipment_planner: "Add Shipment Planner",
    delete_shipment_planner: "Delete Shipment Planner",
    shipment_planners: "Shipment Planners",
    delete_shipment_planner_confirm: "This action is not reversible!",
    add_shipment: "Add Shipment",
    shipment_number: "Shipment #",
    mark_as_draft: "Mark as Draft",
    mark_as_in_route: "Mark as In Route",
    mark_as_delivered: "Mark as Delivered",
    cancel_shipment: "Cancel Shipment",
    finalize_shipment: "Finalize Shipment",
};
